<!--页面的头部  复制功能-->
<template>
  <el-dialog :title="$t('lang.duplicate')" :visible.sync="dialogVisible" width="500px" class="duplicate" :before-close="handleClose">
    <div class="content">
      <el-form :model="dateTime" :rules="rules" ref="dateTime" label-width="100%" class="demo-ruleForm">
        <el-form-item :label="$t('lang.selectEvents')" prop="mode">
          <el-select v-model="dateTime.mode" placeholder="">
            <el-option v-for="item in timeMode" :key="item.value" :label="$t(`lang.${item.label}`)" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="select_event_date" label="" prop="date">
          <!-- 选择日期 -->
          <el-date-picker v-model="dateTime.date" class="date" type="date" value-format="yyyy-MM-dd" popper-class="date_option" @change="changeFromTime" :picker-options="pickerOptions" placeholder="">
          </el-date-picker>
          <!-- 选择时间 -->
          <!-- <el-time-select
            v-if="dateTime.mode != 2"
            placeholder=""
            class="time"
            v-model="dateTime.fromStartTime"
            popper-class="date_option"
            :picker-options="{
              start: '00:00',
              step: steps[dateTime.mode],
              end: '24:00',
            }"
          >
          </el-time-select> -->
          <el-select v-if="dateTime.mode != 2" class="time" placeholder="" popper-class="date_option" v-model="dateTime.fromStartTime">
            <el-option v-for="item in DayTimePulldown" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span class="separator" v-if="dateTime.mode != 2">- </span>
          <div class="end_time" v-if="dateTime.mode != 2">
            {{ fromEndTime }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.repeat')" prop="toDate">
          <div class="repeat_date">
            <el-date-picker class="date" type="date" value-format="yyyy-MM-dd" v-model="dateTime.toDate" popper-class="date_option" @change="changeToTime" :picker-options="pickerOptions" placeholder="">
            </el-date-picker>
            <!-- <el-time-select
              v-if="dateTime.mode != 2"
              placeholder=""
              v-model="dateTime.toStartTime"
              class="time"
              popper-class="date_option"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
              }"
            >
            </el-time-select> -->
            <el-select v-if="dateTime.mode != 2" class="time" placeholder="" popper-class="date_option" v-model="dateTime.toStartTime">
              <el-option v-for="item in DayTimePulldown" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="separator" v-if="dateTime.mode != 2">-</span>
            <div class="end_time" v-if="dateTime.mode != 2">
              {{ toEndTime }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("lang.cancel") }}</el-button>
      <el-button type="primary" @click="submitForm('dateTime')">{{ $t("lang.apply") }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { duplicateEvent } from '@/service/playout.js'
import Bus from '@/assets/js/vueBus.js'
import toTips from '@/assets/js/toTipsObj'
import { creatAccount } from '@/assets/js/common/creatAccount.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'

export default {
  props: {
    dialogVisible: Boolean
  },
  data () {
    return {
      // 时间选择
      timeMode: [
        {
          label: 'halfHour',
          value: '0'
        },
        {
          label: 'anHour',
          value: '1'
        },
        {
          label: 'allDay',
          value: '2'
        }
      ],
      steps: ['00:30', '00:30'],
      // 表单内容
      dateTime: {
        mode: '0',
        date: '',
        fromStartTime: '',
        toDate: '',
        toStartTime: ''
      },
      duplicateEvent: {
        fromStartTime: '',
        fromEndTime: '',
        toStartTime: '',
        toEndTime: '',
        rid: '',
        copy: true
      },
      DayTimePulldown: [
        { value: '00:00', label: '12:00 AM' }, { value: '00:30', label: '12:30 AM' }, { value: '01:00', label: '01:00 AM' }, { value: '01:30', label: '01:30 AM' }, { value: '02:00', label: '02:00 AM' }, { value: '02:30', label: '02:30 AM' }, { value: '03:00', label: '03:00 AM' }, { value: '03:30', label: '03:30 AM' }, { value: '04:00', label: '04:00 AM' }, { value: '04:30', label: '04:30 AM' }, { value: '05:00', label: '05:00 AM' }, { value: '05:30', label: '05:30 AM' }, { value: '06:00', label: '06:00 AM' }, { value: '06:30', label: '06:30 AM' }, { value: '07:00', label: '07:00 AM' }, { value: '07:30', label: '07:30 AM' }, { value: '08:00', label: '08:00 AM' }, { value: '08:30', label: '08:30 AM' }, { value: '09:00', label: '09:00 AM' }, { value: '09:30', label: '09:30 AM' }, { value: '10:00', label: '10:00 AM' }, { value: '10:30', label: '10:30 AM' }, { value: '11:00', label: '11:00 AM' }, { value: '11:30', label: '11:30 AM' }, { value: '12:00', label: '12:00 PM' }, { value: '12:30', label: '12:30 PM' }, { value: '13:00', label: '01:00 PM' }, { value: '13:30', label: '01:30 PM' }, { value: '14:00', label: '02:00 PM' }, { value: '14:30', label: '02:30 PM' }, { value: '15:00', label: '03:00 PM' }, { value: '15:30', label: '03:30 PM' }, { value: '16:00', label: '04:00 PM' }, { value: '16:30', label: '04:30 PM' }, { value: '17:00', label: '05:00 PM' }, { value: '17:30', label: '05:30 PM' }, { value: '18:00', label: '06:00 PM' }, { value: '18:30', label: '06:30 PM' }, { value: '19:00', label: '07:00 PM' }, { value: '19:30', label: '07:30 PM' }, { value: '20:00', label: '08:00 PM' }, { value: '20:30', label: '08:30 PM' }, { value: '21:00', label: '09:00 PM' }, { value: '21:30', label: '09:30 PM' }, { value: '22:00', label: '10:00 PM' }, { value: '22:30', label: '10:30 PM' }, { value: '23:00', label: '11:00 PM' }, { value: '23:30', label: '11:30 PM' }
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < new Date().setHours(0, 0, 0, 0)
        }
      }
    }
  },
  computed: {
    //   计算结束时间
    fromEndTime () {
      if (!this.dateTime.date) return ''
      console.log(`${this.dateTime.date} ${this.dateTime.fromStartTime}`, '00000000000000')
      const startTime = new Date(
        `${this.dateTime.date} ${this.dateTime.fromStartTime}`
      ).getTime()
      const duration = [0.5, 1, 24][Number(this.dateTime.mode)] * 60 * 60 * 1000
      const endTime = new Date(startTime + duration)
      return this.transitionHourly(endTime)
      // return `${this.formatTime(endTime.getHours())}:${this.formatTime(
      //   endTime.getMinutes()
      // )}`
    },
    toEndTime () {
      if (!this.dateTime.toDate) return ''
      const startTime = new Date(
        `${this.dateTime.toDate} ${this.dateTime.toStartTime}`
      ).getTime()
      const duration = [0.5, 1, 24][Number(this.dateTime.mode)] * 60 * 60 * 1000
      const endTime = new Date(startTime + duration)
      return this.transitionHourly(endTime)
      // return `${this.formatTime(endTime.getHours())}:${this.formatTime(
      //   endTime.getMinutes()
      // )}`
    },
    rules () {
      return {
        mode: [
          {
            required: true,
            message: this.$t('lang.selectDateMode'),
            trigger: 'change'
          }
        ],
        date: [
          {
            required: true,
            message: this.$t('lang.selectDateTime'),
            trigger: 'change'
          }
        ],
        toDate: [
          {
            required: true,
            message: this.$t('lang.selectDateTo'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  created () {
  },
  mounted () {
    Bus.$on('playOutVideoR', (r) => {
      // r的数据
      this.duplicateEvent.rid = r.peerId
    })
  },
  watch: {
    dialogVisible (val) {

    }
  },
  methods: {
    // 24小时制转12小时制
    transitionHourly (time) {
      if (time) {
        let type = ''
        let hour = time.getHours()
        let min = time.getMinutes()
        const s = time.getSeconds()
        if (hour >= 0 && hour <= 11) {
          type = 'AM'
          hour = hour == 0 ? 12 : hour
        } else {
          type = 'PM'
          hour = hour == 12 ? hour : hour - 12
        }
        // hour = hour >= 0 && hour < 10 ? `0${hour}` : hour;
        min = min >= 0 && min < 10 ? `0${min}` : min
        return `${hour}:${min} ${type}`
      }
    },
    changeFromTime (val) {
      this.dateTime.fromStartTime = this.dateTime.fromStartTime || '00:00'
    },
    changeToTime (val) {
      this.dateTime.toStartTime = this.dateTime.toStartTime || '00:00'
    },
    formatTime (num) {
      return num > 9 ? String(num) : `0${num}`
    },
    handleClose () {
      // 重置表单及数据
      this.resetData()
      this.resetForm('dateTime')
      this.$emit('update:dialogVisible', false)
    },
    save () {
      //   获取开始结束时间的毫秒数
      this.duplicateEvent.fromStartTime = new Date(
        `${this.dateTime.date} ${this.dateTime.fromStartTime}`
      ).getTime()
      this.duplicateEvent.fromEndTime = new Date(
        `${this.dateTime.date} ${
        this.dateTime.mode == '2' ? '24:00' : this.fromEndTime
        }`
      ).getTime()
      this.duplicateEvent.toStartTime = new Date(
        `${this.dateTime.toDate} ${this.dateTime.toStartTime}`
      ).getTime()
      this.duplicateEvent.toEndTime = new Date(
        `${this.dateTime.toDate} ${
        this.dateTime.mode == '2' ? '24:00' : this.toEndTime
        }`
      ).getTime()
      //   批量复制事件
      duplicateEvent(this.duplicateEvent).then((res) => {
        if (res.status == 200 && res.data.errorCode == '0x0') {
          Bus.$emit('updateEventList')
          this.handleClose()
          return
        }
        // 错误提示
        const errorInfo =
          this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
        this.$message.error(errorInfo)
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          creatAccount()
          playoutAnalyze('welcomeDuplicateDialogSave')
        }
      })
    },
    resetData () {
      this.dateTime.mode = '0'
      this.dateTime.date = ''
      this.dateTime.toDate = ''
      this.dateTime.fromStartTime = ''
      this.dateTime.toStartTime = ''
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="less" scoped>
.duplicate {
  /deep/ .el-form-item__label {
    text-align: left;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
    text-align: left;
  }
  /deep/ .el-dialog .el-dialog__body .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
  /deep/ .select_event_date,
  .repeat_date {
    .el-form-item__content {
      display: flex;
      height: 36px;
      line-height: 36px;
    }
    .el-date-editor.date {
      flex: 2;
    }
    .el-date-editor,
    .end_time {
      flex: 1;
    }
    .end_time {
      background: #444;
      border-radius: 6px;
      color: #fff;
      border: 1px solid #353535;
      height: 36px;
      line-height: 36px;
      text-align: center;
      cursor: not-allowed;
    }
    .separator {
      margin: 0 8px;
    }
  }
  .select_event_date,
  .repeat_date {
    /deep/ .time {
      width: 100px;
      margin-left: 20px;
      .el-input__inner {
        padding: 0 15px;
        text-align: center;
      }
      .el-input__icon {
        display: none;
      }
    }
  }
  .repeat_date {
    display: flex;
    width: 100%;
  }
  /deep/ .el-select {
    width: 100%;
  }
}
</style>
<style lang="less">
.el-popper.date_option {
  z-index: 20030 !important;
  .popper__arrow,
  .popper__arrow:after {
    border-bottom-color: #ebeef5;
  }
}
</style>
